'use client';

import cx from 'classnames';
import PageFooter from '@/common/PageFooter';
import { SectionAnalyticsProvider } from '~/context/common/SectionAnalyticsContext';
import type { LotCarsData } from '~/contracts/dealership';
import TestDriveCenterFaq from './sections/TestDriveCenterFaq';
import TestDriveCenterHero from './sections/TestDriveCenterHero';
import TestDriveCenterHowItWorks from './sections/TestDriveCenterHowItWorks';
import TestDriveCenterLotMap from './sections/TestDriveCenterLotMap';
import TestDriveCenterMobileBar from './sections/TestDriveCenterMobileBar';
import TestDriveCenterNav from './sections/TestDriveCenterNav';
import TestDriveCenterProductReveal from './sections/TestDriveCenterProductReveal';
import TestDriveCenterStatement from './sections/TestDriveCenterStatement';
import TestDriveCenterValueProps from './sections/TestDriveCenterValueProps';
import TestDriveCenterVisit from './sections/TestDriveCenterVisit';
import styles from './TestDriveCenter.module.css';

// Cinematic, scroll-driven brand landing page for the Carvana CDJR Test Drive
// Center. Recreated from the design handoff; replaces the homepage for enabled
// dealerships. Uses its own custom nav and the standard dealership footer (which
// carries the required legal links + per-dealership hours).
export default function TestDriveCenterLanding({
  lotData
}: {
  lotData: LotCarsData;
}) {
  return (
    <SectionAnalyticsProvider section="Test Drive Center">
      <div
        className={cx(
          styles.root,
          'relative flex flex-col overflow-x-clip bg-[var(--cvna-page)] font-[family-name:var(--font-sans)] text-white max-[920px]:pb-[calc(70px+env(safe-area-inset-bottom))]'
        )}
        data-testid="test-drive-center-landing"
      >
        <TestDriveCenterNav />
        <TestDriveCenterHero />
        <TestDriveCenterStatement />
        <TestDriveCenterValueProps />
        <TestDriveCenterLotMap lotData={lotData} />
        <TestDriveCenterProductReveal />
        <TestDriveCenterHowItWorks />
        <TestDriveCenterVisit />
        <TestDriveCenterFaq />
        <PageFooter />
        <TestDriveCenterMobileBar />
      </div>
    </SectionAnalyticsProvider>
  );
}
